module.exports = __webpack_public_path__ + "img/detail5-4.dfc938e5.png";